var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { MDCDialog } from '@material/dialog';
import WithRender from './Dialog.html';
let Dialog = class Dialog extends Vue {
    constructor() {
        super(...arguments);
        // holds all class names to be applied to dialog box
        this.classes_ = {};
        // holds all inline styles to be applied to dialog box
        this.styles_ = {};
    }
    get escapeAction() {
        return this.escape ? 'cancel' : '';
    }
    mounted() {
        const dialog = this.dialog = new MDCDialog(this.$el);
        dialog.listen('MDCDialog:opened', () => this.$emit('open'));
        dialog.listen('MDCDialog:closed', (event) => {
            const action = event.detail.action;
            if (action) {
                this.$emit(action);
            }
            this.$emit('close');
        });
        // Allow escape key
        dialog.escapeKeyAction = this.escapeAction;
        dialog.scrimClickAction = this.escapeAction;
    }
    open() {
        this.dialog.open();
    }
    close(reason) {
        this.dialog.close(reason);
    }
    beforeDestroy() {
        this.dialog.destroy();
    }
};
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], Dialog.prototype, "escape", void 0);
Dialog = __decorate([
    WithRender,
    Component({})
], Dialog);
export default Dialog;
//# sourceMappingURL=Dialog.js.map